import cn from "classnames"
import { Fragment } from "react"

import { getColorBySeverity } from "@/domain/vulnerability"

import styles from "./SeverityTag.module.scss"

import type { SeverityTagProps } from "."

export const SeverityTag = (props: SeverityTagProps) => {
  const { className, severity, t, latter, cvss, ghost } = props
  const text = props.text || t(`vulnerabilities.${severity.toLowerCase()}`)
  const withCvss = cvss !== undefined
  const Wrapper = withCvss ? "span" : Fragment
  const propsWrapper = withCvss ? { className: styles.wrapper } : {}
  const color = getColorBySeverity(severity)
  const style = ghost
    ? { color, borderColor: color }
    : { backgroundColor: color }
  const nextClassName = cn(
    styles.container,
    { [styles.latter]: latter, [styles.ghost]: ghost },
    className
  )

  return (
    <Wrapper {...propsWrapper}>
      <span style={style} className={nextClassName} data-tooltip-content={text}>
        <span>{text}</span>
      </span>
      {withCvss && (
        <span>
          {cvss > 0 ? ` (CVSS ${cvss})` : ` (${t("vulnerabilities.noCvss")})`}
        </span>
      )}
    </Wrapper>
  )
}
